import { styled } from '../../stitches.config';

const Box = styled('span', {});

export default Box;
